import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DateFilter from "../../Components/CommonComponent/Dropdown/DateFilter";
import { useContext } from "react";
import { CommonContext } from "../../App";

export default function InventoryBookTabsButtons() {
  const location = useLocation();
  const { t } = useTranslation();

  const tabs = [
    { title: t("view"), path: "inventory-category-table" },
    { title: t("create"), path: "category" },

  ];
    const { setDateRange } = useContext(CommonContext);

  return (
    <div>
     <header className="tabs-header     sticky top-0 z-[990]  py-1 pt-2 flex gap-3 justify-between px-2    ">
     
        <div className="flex gap-3">
            {tabs.map((tab) => {

          let isActive = false;

          if (tab.path === "inventory-category-table") {
            isActive =
              location.pathname === "/inventory-books" ||
              location.pathname === "/inventory-books/inventory-items-table" ||
              location.pathname === "/inventory-books/sub-category-table" ||
              location.pathname === "/inventory-books/item-details" ||
              location.pathname.startsWith("/inventory-books/inventory-category-table");
          }

          if (tab.path === "category") {
            isActive =
              location.pathname.startsWith("/inventory-books/category");
          }
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`tab no-underline rounded-1 h-7 mt-[3px] pt-[3px] text-sm  px-2  ${isActive
                ? `bg-theme-headerBg text-theme-color font-medium border-1 border-theme-headerBg`
                  : `text-theme-tabColor border-1  border-black hover:!border-theme-headerBg  hover:!text-theme-headerBg `
                  }`}
            >
              {tab.title}
            </Link>
          );
        })}
        </div>
         <div className="" >
          <DateFilter
           storageKey="inventory"
            customMode="range"
            availableFilters={[
              "default",
              "today",
              "yesterday",
              "lastWeek",
              "last15",
              "lastMonth",
              "thisMonth",
              "custom",
            ]}
            onChange={(r) =>
              setDateRange({
                startDate: r.startDate,
                endDate: r.endDate,
              })
            }
          />
        </div>
      </header>

      <main className="tab-content">
        <Outlet />
      </main>
    </div>
  );
}

